import React, { useEffect, useState } from 'react';
import { collection, query, where, onSnapshot, orderBy } from 'firebase/firestore';
import { auth, db } from '../firebase';

export default function Notificaciones() {
  const [notificaciones, setNotificaciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const user = auth.currentUser;

  useEffect(() => {
    if (!user) {
      setNotificaciones([]);
      setLoading(false);
      return;
    }

    // Escuchar notificaciones globales
    const qGlobal = query(
      collection(db, 'notificaciones'),
      where('global', '==', true),
      orderBy('timestamp', 'desc')
    );

    // Escuchar notificaciones específicas que incluyen el UID
    const qEspecificas = query(
      collection(db, 'notificaciones'),
      where('usuarios', 'array-contains', user.uid),
      orderBy('timestamp', 'desc')
    );

    // Unir dos streams
    const unsubscribeGlobal = onSnapshot(qGlobal, snapshot => {
      const notifsGlobal = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setNotificaciones(prev => {
        // Mantener unidas y ordenadas
        const merged = [...prev.filter(n => !n.global), ...notifsGlobal];
        merged.sort((a, b) => b.timestamp?.toDate() - a.timestamp?.toDate());
        return merged;
      });
      setLoading(false);
    });

    const unsubscribeEspecificas = onSnapshot(qEspecificas, snapshot => {
      const notifsEspecificas = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setNotificaciones(prev => {
        const merged = [...prev.filter(n => n.global), ...notifsEspecificas];
        merged.sort((a, b) => b.timestamp?.toDate() - a.timestamp?.toDate());
        return merged;
      });
      setLoading(false);
    });

    return () => {
      unsubscribeGlobal();
      unsubscribeEspecificas();
    };
  }, [user]);

  if (loading) return <p>Cargando notificaciones...</p>;

  if (notificaciones.length === 0) return <p>No tienes notificaciones nuevas 📭</p>;

  return (
    <div>
      <h2>Notificaciones</h2>
      <ul>
        {notificaciones.map(({ id, mensaje, timestamp }) => (
          <li key={id} style={{ marginBottom: 10 }}>
            <p>{mensaje}</p>
            <small>{timestamp?.toDate().toLocaleString() || 'Fecha no disponible'}</small>
          </li>
        ))}
      </ul>
    </div>
  );
}
